import { createSvgIcon } from '@mui/material'

export const AiPowered = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="scale(0.1297 0.1548)">
      <path
        d="M109.666 66.3327L92.4997 58.4993L109.666 50.666L117.5 33.4993L125.333 50.666L142.5 58.4993L125.333 66.3327L117.5 83.4993L109.666 66.3327ZM25.833 100.166L33.6663 82.9993L50.833 75.166L33.6663 67.3327L25.833 50.166L17.9997 67.3327L0.833008 75.166L17.9997 82.9993L25.833 100.166ZM63.333 58.4993L72.4163 38.416L92.4997 29.3327L72.4163 20.2493L63.333 0.166016L54.2497 20.2493L34.1663 29.3327L54.2497 38.416L63.333 58.4993ZM29.9997 154.333L79.9997 104.249L113.333 137.583L184.166 57.916L172.416 46.166L113.333 112.583L79.9997 79.2493L17.4997 141.833L29.9997 154.333Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </g>
  </svg>,
  'AiPowered'
)
